



























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { omegaup } from '../../omegaup';
import T from '../../lang';
import { types } from '../../api_types';

import problem_FinderWizard from './FinderWizard.vue';
import problem_SearchBar from './SearchBar.vue';
import problem_BaseList from './BaseList.vue';

@Component({
  components: {
    'omegaup-problem-base-list': problem_BaseList,
    'omegaup-problem-finder': problem_FinderWizard,
    'omegaup-problem-search-bar': problem_SearchBar,
  },
})
export default class List extends Vue {
  @Prop() problems!: omegaup.Problem;
  @Prop() loggedIn!: boolean;
  @Prop() selectedTags!: string[];
  @Prop() pagerItems!: types.PageItem[];
  @Prop() wizardTags!: omegaup.Tag[];
  @Prop() language!: string;
  @Prop() languages!: string[];
  @Prop() keyword!: string;
  @Prop() modes!: string[];
  @Prop() columns!: string[];
  @Prop() mode!: string;
  @Prop() column!: string;
  @Prop() tags!: string[];
  @Prop() onlyQualitySeal!: boolean;
  @Prop() sortOrder!: string;
  @Prop() columnName!: string;
  @Prop() searchResultProblems!: types.ListItem[];

  T = T;
  omegaup = omegaup;
  showFinderWizard = false;

  wizardSearch(queryParameters: omegaup.QueryParameters): void {
    this.$emit('wizard-search', queryParameters);
  }
}
